import fileService from '../../services/fileService'

export const file = {
    namespaced: true,
    state: {
        received: [
            /* {
                Id: 51518,
                Name: 'Report.doc',
                FileType: 'doc',
                Size: '518618',
                IsNew: false,
                IsRead: true,
                DateAdded: '2019-11-06T16:32:35'
            },
            {
                Id: 51519,
                Name: 'Speadsheet.xlsx',
                FileType: 'xlsx',
                Size: '985612',
                IsNew: true,
                IsRead: false,
                DateAdded: '2019-11-06T16:32:35'
            },
            {
                Id: 51520,
                Name: 'Report.doc',
                FileType: 'doc',
                Size: '518618',
                IsNew: false,
                IsRead: true,
                DateAdded: '2019-11-06T16:32:35'
            },
            {
                Id: 51521,
                Name: 'Report.doc',
                FileType: 'doc',
                Size: '518618',
                IsNew: false,
                IsRead: false,
                DateAdded: '2019-11-06T16:32:35'
            },
            {
                Id: 51522,
                Name: 'Report.doc',
                FileType: 'doc',
                Size: '518618',
                IsNew: false,
                IsRead: false,
                DateAdded: '2019-11-06T16:32:35'
            },
            {
                Id: 51523,
                Name: 'Report.doc',
                FileType: 'doc',
                Size: '518618',
                IsNew: false,
                IsRead: false,
                DateAdded: '2019-11-06T16:32:35'
            } */
        ],
        folders: [

        ],
        selected: null,
        selectedFolder: null
    },
    mutations: {
        SET_RECEIVED_FILES(state, files) {
            state.received = files
        },
        SET_FILE(state, file) {
            state.selected = file
        },
        SET_FOLDER(state, folder) {
            state.selectedFolder = folder
        },
        CLEAR_SELECTED_FILE(state) {
            state.selected = null
        },
        CLEAR_SELECTED_FOLDER(state) {
            state.selectedFolder = null
        }
    },
    actions : {
        fetchReceivedFiles({ commit, state, dispatch }, folderId) {
            return new Promise((resolve, reject) => {
                commit('SET_FOLDER', folderId)

                fileService.getFiles()
                    .then(response => {
                        commit('SET_RECEIVED_FILES', response.data)
                        resolve()
                    })
                    .catch(error => {
                        console.log(error)
                        reject()
                    })
            })
        },
        fetchReceivedFile({commit, getters, dispatch}, id) {
            console.log(id)
            let file = getters.getReceivedFileById(id)
            console.log(file)

            if (file) {
                commit('SET_FILE', file)
            } else {
                //check API for file
            }
        },
        clearSelectedFile({commit, getters, dispatch}) {
            commit('CLEAR_SELECTED_FILE')
        }
    },
    getters: {
        getAllReceived: state => {
            return state.received
        },
        getReceivedFileById: state => id => {
            return state.received.find(file => file.Id === id)
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/file.js